// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0b5e01bc","239":"1150dd4e","862":"e7ab7e3d"}[chunkId] + ".chunk.js";
};